import { PDF_STONE } from "reporting/pdf/pdfTheme";

export const FUND_PLANNER_DISCLOSURE_SECTIONS = [
  {
    title: "Report Nature and Provider Roles",
    paragraphs: [
      "This report was generated by a user through FundPlanner, a module of the CoreCompass platform developed and owned by Core2tek LLC (\u201cCore2tek\u201d), the Technology Provider. Where platform access is provided through another entity (the \u201cPlatform Provider\u201d), that relationship is governed by a separate agreement. The Technology Provider and Platform Provider may be affiliated entities.",
      "Core2tek provides software and technology infrastructure and does not provide financial, investment, municipal advisory, legal, accounting, or other professional advice. Generation of this report does not, by itself, constitute preparation, review, verification, approval, or certification by the Platform Provider or any advisor. Any separate advisory relationship is governed by the applicable engagement agreement; platform access and report generation do not expand the scope of that engagement.",
    ],
  },
  {
    title: "Data and Calculations",
    paragraphs: [
      "This report reflects the accounts, holdings, transactions, reporting dates, and other information entered, imported, or selected by the user. It may incorporate third-party data and calculations based on platform methodologies and assumptions. Incomplete or inaccurate inputs, omitted transactions, unavailable pricing, or differences in reporting conventions may affect the results. Core2tek does not guarantee the accuracy, completeness, or reliability of the report or its underlying data. The user is responsible for verifying the information and determining whether the report is suitable for its intended purpose.",
    ],
  },
  {
    title: "Valuations and Analytical Measures",
    paragraphs: [
      "Market values, where presented, reflect the applicable valuation dates and available pricing or valuation inputs. They may be estimates and may differ from prices obtainable in an actual transaction. Book values, accrued interest, income, yields, returns, and maturity measures depend on the underlying data and calculation conventions and may differ from custodian statements, accounting records, or other reporting systems. Any projected cash flows or earnings are estimates subject to their stated or underlying assumptions and are not guarantees of future results. Yield measures should not be interpreted as realized investment returns unless expressly identified as such.",
    ],
  },
  {
    title: "Use and Compliance",
    paragraphs: [
      "This report supports portfolio analysis and information management. It does not, by itself, constitute investment advice, a recommendation to purchase, sell, hold, or otherwise transact in any security or financial product, an audit or assurance opinion, or a determination of compliance with applicable law, investment policy, accounting standards, or contractual requirements. This report is not an offer to buy or sell, or a solicitation of an offer to buy or sell, any security or financial product. Generation of the report does not establish that required reviews, approvals, certifications, or signatures have been obtained. Users remain responsible for satisfying applicable reporting requirements and obtaining appropriate professional review.",
    ],
  },
  {
    title: "Applicable Terms",
    paragraphs: [
      "Use of CoreCompass and its outputs is subject to the applicable Terms of Service and any separate agreement with the Platform Provider. This disclosure summarizes the nature and limitations of this report and does not amend those agreements.",
    ],
  },
];

function drawSectionLead(doc, title, paragraph, x, y, width) {
  const lead = `${title}.`;
  doc.setFont("helvetica", "bold");
  const gap = doc.getTextWidth(" ");
  const leadWidth = doc.getTextWidth(lead);
  const words = paragraph.split(/\s+/);
  const firstLineWords = [];
  let firstLineWidth = 0;
  const firstLineLimit = Math.max(0, width - leadWidth - gap);

  doc.setFont("helvetica", "normal");
  while (words.length) {
    const candidate = [...firstLineWords, words[0]].join(" ");
    const candidateWidth = doc.getTextWidth(candidate);
    if (firstLineWords.length && candidateWidth > firstLineLimit) break;
    firstLineWords.push(words.shift());
    firstLineWidth = candidateWidth;
    if (firstLineWidth >= firstLineLimit) break;
  }

  doc.setFont("helvetica", "bold");
  doc.text(lead, x, y);
  doc.setFont("helvetica", "normal");
  if (firstLineWords.length) {
    doc.text(firstLineWords.join(" "), x + leadWidth + gap, y);
  }

  const remainingLines = words.length
    ? doc.splitTextToSize(words.join(" "), width)
    : [];
  if (remainingLines.length) {
    doc.text(remainingLines, x, y + 8.8, { lineHeightFactor: 1.35 });
  }

  return y + (1 + remainingLines.length) * 8.8;
}

export function renderFundPlannerDisclosurePdf(ctx) {
  ctx.startSection({
    orientation: "portrait",
    contentMargins: { top: 54, bottom: 48 },
    decorate: false,
  });

  const { doc, margins, usableWidth } = ctx;
  let y = margins.top;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(...PDF_STONE.primary);
  doc.text("Disclosures", margins.left, y);
  y += 20;

  FUND_PLANNER_DISCLOSURE_SECTIONS.forEach((section) => {
    doc.setFontSize(6.5);
    doc.setTextColor(92);
    y = drawSectionLead(
      doc,
      section.title,
      section.paragraphs[0],
      margins.left,
      y,
      usableWidth
    );
    y += 7;

    section.paragraphs.slice(1).forEach((paragraph) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6.5);
      doc.setTextColor(105);
      const lines = doc.splitTextToSize(paragraph, usableWidth);
      doc.text(lines, margins.left, y, { lineHeightFactor: 1.35 });
      y += lines.length * 8.8 + 7;
    });

    y += 2;
  });
}

export default renderFundPlannerDisclosurePdf;
